import {Auth0Lock} from 'auth0-lock';
import {AUTH_CONFIG, ACCESS_TOKEN, ID_TOKEN, EXPIRES_AT} from '../utils';

/**
 * From Auth0 Embedded login sample:
 * https://github.com/auth0-samples/auth0-react-samples/blob/embedded-login/01-Embedded-Login
 */
export default class Auth {

    lock = new Auth0Lock(AUTH_CONFIG.clientId, AUTH_CONFIG.domain, {
        rememberLastLogin: false,
        allowedConnections: ['google-oauth2'],
        theme: {
            logo: 'https://s3.amazonaws.com/q4-touch/q4admin-auth-logo/Q4_RGB.svg',
            primaryColor: '#0f5ca3'
        },
        languageDictionary: {
            title: 'Contacts Admin'
        },
        auth: {
            redirectUrl: AUTH_CONFIG.callbackUrl,
            responseType: 'token id_token',
            params: {
              scope: 'openid roles email'
            }
        }
    });

    /**
     * Constructor
     * @param props
     */
    constructor(props) {
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.onAuthenticate = props && props.onAuthenticate;

        this.session();
    }

    /**
     * Handle authentication
     * @returns {Promise<any>}
     */
    handleAuthentication() {
        return new Promise((resolve, reject) => {
            this.lock.on('authenticated', (result) => {

                if (!_isValidAuthResult(result)) {
                    return reject();
                }

                this.lock.getUserInfo(result.accessToken, (err, profile) => {
                    this.onAuthenticate(profile, result.accessToken);
                });

                _setSession(result);
                resolve();
            });

            this.lock.on('authorization_error', () => reject());
        });
    }

    /**
     * Run once per session
     */
    session() {
        if (this.isAuthenticated()) {
            const accessToken = localStorage.getItem(ACCESS_TOKEN);

            this.lock.getUserInfo(accessToken, (err, profile) => {
                this.onAuthenticate(profile, accessToken);
            });
        }
    }

    /**
     * Login
     */
    login() {
        this.lock.show();
    }

    /**
     * Check if is authenticated
     * @returns {boolean}
     */
    isAuthenticated = () => {
        return new Date().getTime() < JSON.parse(localStorage.getItem(EXPIRES_AT));
    };

    /**
     * Logout
     */
    logout = () => {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(ID_TOKEN);
        localStorage.removeItem(EXPIRES_AT);

        this.onAuthenticate();
    }
}


/**
 * Set Session
 * @param result
 * @private
 */
function _setSession(result) {
    localStorage.setItem(ACCESS_TOKEN, result.accessToken);
    localStorage.setItem(ID_TOKEN, result.idToken);
    localStorage.setItem(EXPIRES_AT, JSON.stringify((result.expiresIn * 1000) + new Date().getTime()));
}

/**
 * Validate authentication
 * @param result
 * @returns {*|boolean}
 * @private
 */
function _isValidAuthResult(result) {
    const {accessToken, idToken, idTokenPayload} = result;
    const roles = [].concat((idTokenPayload && idTokenPayload.roles) || []);
    const products = [].concat((idTokenPayload && idTokenPayload.products) || []);

    return (accessToken && idToken && roles.includes('admin') && products.includes('contact'));
}